const ligue1Content = {
  preview: `Ligue 1 2024/25 enters a new era following PSG's continued dominance and the growing 
  competitiveness of clubs like Monaco, Marseille and Lille. With PSG's transformation into a more 
  team-oriented outfit following the departures of their galacticos, the title race is more open 
  than it has been in years.`,

  keyStories: [
    {
      title: "PSG's New Identity",
      desc: "Without Mbappe, Neymar and Messi, PSG are building a more cohesive team unit that could prove more sustainable long-term."
    },
    {
      title: "Monaco's Rise",
      desc: "The Principality club have invested smartly and possess a squad capable of mounting a genuine title challenge."
    },
  ],

  titleContenders: ["PSG", "Monaco", "Marseille", "Lille", "Lyon"],

  fullPreview: `
    <h3>Ligue 1 2024/25 — Complete Analysis</h3>
    <p>French football's top division is experiencing a period of transition and opportunity. 
    With the superstar era at PSG ending, other clubs sense a genuine chance to end the Parisian 
    club's domestic stranglehold.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>PSG remain favorites through squad quality and financial resources, but the title race 
    is genuinely more competitive than at any point in the past decade.</p>
  `,
};

export default ligue1Content;